import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  const fakeModules = [1, 2, 3, 4, 5];

  return (
    <Box className={classes.container} flexGrow={1}>
      <Box className="header-bar" mb={3}>
        <Box px={2}>
          <Skeleton variant="circle" width={32} height={32} />
        </Box>
        <Box className="toggle-side-menu" ml="auto">
          <Skeleton variant="text" width={100} />
        </Box>
      </Box>
      {fakeModules.map(item => (
        <Box key={item} px={2} py={2} display="flex">
          <Box mr={1}>
            <Skeleton variant="circle" width={32} height={32} />
          </Box>
          <Box display="flex" flexDirection="column" flexGrow={1}>
            <Box mb={2} mt={1 / 2}>
              <Skeleton variant="text" width="70%" />
            </Box>
            <Box>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="50%" />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Loading;
